import { ChakraBox } from '@equip.health/ui';

import ChatAvatar from './ChatAvatar';

export interface ChatGroupChannelAvatarProps {
  user1Nickname: string;
  user2Nickname: string;
}

const ChatGroupChannelAvatar = ({
  user1Nickname,
  user2Nickname,
}: ChatGroupChannelAvatarProps) => (
  <ChakraBox height="40px" position="relative" width="40px">
    <ChakraBox bottom="0" left="0" position="absolute">
      <ChatAvatar name={user1Nickname ?? ''} size="sm" />
    </ChakraBox>

    <ChakraBox
      background="white"
      borderRadius="50%"
      paddingBottom="2px"
      paddingLeft="2px"
      position="absolute"
      right="0"
      top="0"
    >
      <ChatAvatar name={user2Nickname ?? ''} size="sm" />
    </ChakraBox>
  </ChakraBox>
);

export default ChatGroupChannelAvatar;
